export default __webpack_public_path__ + "static/media/placeholder_600x400.d8d1091f.svg";